// @flow
import * as React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import Icon from 'components/_particles/icon/react/Icon';
import Image from 'components/atoms/image/react/Image';
import type { ImageType } from 'components/atoms/image/react/Image';
import Headline from 'components/atoms/headline/Headline';
import IconLink from 'components/atoms/icon-link/IconLink';
import initOverlayLink from 'components/molecules/teaser/teaser';

export type TeaserType = {
  horizontal?: boolean,
  small?: boolean,
  attributes?: any,
  image: ImageType,
  date?: {
    date: string,
    text: string,
  },
  mediaType?: string,
  meta?: Array<{icon?: string, text: string}>,
  headline: string,
  text?: string,
  hashtags?: Array<{link: string, text: string}>,
  moreLink?: {
    link: string,
    text: string
  },
  publication?: boolean,
  className?: string,
  copyright?: string,
};

export default class Teaser extends React.Component<TeaserType> {
  overlay: null | IconLink = null;

  initTeaserOverlay: (() => void) = () => {
    if (this.overlay) {
      // eslint-disable-next-line react/no-find-dom-node
      initOverlayLink(ReactDOM.findDOMNode(this.overlay));
    }
  }

  componentDidMount() {
    this.initTeaserOverlay();
  }

  render(): React$Element<"article"> {
    return (
      <article className={classNames(
        {
          teaser: true,
          'teaser--horizontal': this.props.horizontal,
          'teaser--small': this.props.small,
        },
        this.props.className,
      )} {...this.props.attributes}>

        { ((this.props.image ||
          this.props.date) ||
          (!this.props.image && this.props.mediaType)) && (
          <div
            className={
              `teaser__image
              ${
                (!this.props.image || (this.props.image && !this.props.image.src))
                && this.props.mediaType ? 'teaser__image--placeholder' : ''
              }`
            }
          >
            {this.props.date && (
              <div className='teaser__date'>
                <Icon icon='calendar' className='teaser__date-icon'/>
                <time className='teaser__date-text' dateTime={this.props.date.date}>{this.props.date.text}</time>
              </div>
            )}

            {this.props.mediaType && (
              <div className='teaser__image-media'>
                <Image {...this.props.image}/>
                <div className='media-button teaser__media-button'>
                  <Icon icon={this.props.mediaType} className='media-button__icon'/>
                </div>
              </div>
            )}

            {this.props.publication && (
              <div className='teaser__image-publication'>
                <div className='teaser__image-cover'>
                  <Image {...this.props.image}/>
                </div>
              </div>
            )}

            {!this.props.mediaType && !this.props.publication && this.props.image.src && (
              <Image {...this.props.image}/>
            )}

            {this.props.copyright &&
              <div className="figure__copyright">
                <div className="copyright">
                  <Icon icon='camera' className='copyright__icon'/>
                  <span className="copyright__text">
                    {this.props.copyright}
                  </span>
                </div>
              </div>
            }
          </div>
        )
        }

        <div className='teaser__content'>
          <div className='teaser__content-inner'>

            <div className='teaser__header'>
              {this.props.meta && (
                <ul className='teaser__meta'>
                  {this.props.meta.map((item, index) => (
                    <li className='teaser__meta-item' key={index}>
                      {item.icon && (
                        <Icon icon={item.icon} className='teaser__meta-icon'/>
                      )}
                      <span className='teaser__meta-text'>{item.text}</span>
                    </li>
                  ))}
                </ul>
              )}
              <div className='teaser__headline'>
                <Headline size={3} level={3}>{this.props.headline}</Headline>
              </div>
            </div>

            {this.props.text && <div dangerouslySetInnerHTML={{ __html: this.props.text }} className='teaser__text'></div>}

            <div className='teaser__footer'>
              {this.props.hashtags && (
                <ul className='teaser__hashtags'>
                  {this.props.hashtags.map((tag, index) => (
                    <li key={index} className='teaser__hashtag'>
                      <a className='teaser__hashtag-link' href={tag.link}>{tag.text}</a>
                    </li>
                  ))}
                </ul>
              )}
              {this.props.moreLink && (
                <IconLink
                  large={true}
                  modest={true}
                  icon='arrow-right'
                  link={this.props.moreLink.link}
                  className='teaser__overlay-link--js'
                  ref={(element) => {
                    this.overlay = element;
                  }}>
                    {this.props.moreLink.text}
                </IconLink>
              )}
            </div>
          </div>
        </div>
      </article>
    );
  }
}
